import { graphql } from "gatsby";
import { ProgressBarBasic, ProgressBarSmall } from "../../../../src/examples/components/ProgressBar";
import * as React from 'react';
export default {
  graphql,
  ProgressBarBasic,
  ProgressBarSmall,
  React
};